import type { IconRawData } from "./Icon";

/**
 * Preloaded (bundled) cache for icons that need to be
 * rendered server-side. This is used primarily for the
 * stencil pages.
 */
export const preloadCache: { [index: string]: IconRawData } = {
  "regular:angle-left": {
    xml: '<path d="m166.5 424.5-143.1-152c-4.375-4.625-6.562-10.56-6.562-16.5 0-5.938 2.188-11.88 6.562-16.5l143.1-152c9.125-9.625 24.31-10.03 33.93-.9375 9.688 9.125 10.03 24.38.9375 33.94l-128.4 135.5 128.4 135.5c9.094 9.562 8.75 24.75-.9375 33.94-9.53 9.0575-24.73 8.6575-33.93-.9425z"/>',
    viewBox: "0 0 256 512",
  },
  "regular:angle-down": {
    xml: '<path d="m360.5 217.5-152 143.1c-4.6 5.2-10.6 7.4-16.5 7.4s-11.88-2.188-16.5-6.562l-152-143.938c-9.63-9.2-10.03-24.4-.94-34 9.13-9.7 24.38-10 33.94-.9l135.5 128.3 135.5-128.4c9.562-9.094 24.75-8.75 33.94.9375 9.06 9.6625 8.66 24.8625-.94 34.0625z"/>',
    viewBox: "0 0 384 512",
  },
  "solid:notebook": {
    xml: '<path d="m416 0h-192v512h192c35.35 0 64-28.65 64-64v-384c0-35.35-28.7-64-64-64zm-352 64v40h-40c-13.25 0-24 10.8-24 24s10.75 24 24 24h40v80h-40c-13.25 0-24 10.8-24 24s10.75 24 24 24h40v80h-40c-13.25 0-24 10.8-24 24s10.75 24 24 24h40v40c0 35.35 28.65 64 64 64h64v-512h-64c-35.35 0-64 28.65-64 64z"/>',
    viewBox: "0 0 512 512",
  },
};
